module.exports = __webpack_public_path__ + "assets/img/146514.a6fc500e.png";